var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 14,
    viewBox: "0 0 7 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12513 4.93736L2.30347 1.1157C2.06897 0.88131 1.75097 0.749678 1.41943 0.749756C1.08788 0.749834 0.76994 0.881616 0.535555 1.11611C0.301171 1.35061 0.169539 1.66861 0.169617 2.00016C0.169695 2.3317 0.301477 2.64964 0.535972 2.88403L4.35763 6.70486C4.39643 6.74357 4.42722 6.78955 4.44823 6.84017C4.46923 6.89079 4.48004 6.94506 4.48004 6.99986C4.48004 7.05467 4.46923 7.10894 4.44823 7.15956C4.42722 7.21018 4.39643 7.25616 4.35763 7.29486L0.535972 11.1157C0.301477 11.3501 0.169695 11.668 0.169617 11.9996C0.169539 12.3311 0.301171 12.6491 0.535555 12.8836C0.76994 13.1181 1.08788 13.2499 1.41943 13.25C1.75097 13.25 2.06897 13.1184 2.30347 12.884L6.12513 9.06236C6.67116 8.51483 6.97778 7.77312 6.97778 6.99986C6.97778 6.2266 6.67116 5.48489 6.12513 4.93736Z",
    fill: "#374957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.e8f2b38821a4ba646cc35436ebf65086.svg";
export { ForwardRef as ReactComponent };